import gql from 'graphql-tag'

export const GET_VIEWER_PARTNER = gql`
  query getViewerPartner {
    viewer {
      id
      isPartner
    }
  }
`

export default GET_VIEWER_PARTNER
